export const MAX_VISIBLE_OPTED_OUT_NAMES = 2

export type OptedOutCellState =
  | { status: 'yes' }
  | { status: 'no' }
  | { status: 'partial', visibleText: string, fullText: string }

interface OptedOutInstructorLike {
  title: string
}

interface GetOptedOutCellStateOptions {
  // Fallback for `isEffectivelyFullyOptedOut` on rows served before the BE ships it, so the
  // column doesn't silently misreport existing opted-out sections as "No" during rollout.
  legacyIsOptedOut?: unknown
}

export const getOptedOutCellState = (
  isEffectivelyFullyOptedOut: unknown,
  optedOutInstructors: unknown,
  options: GetOptedOutCellStateOptions = {}
): OptedOutCellState => {
  const isFullyOptedOut = isEffectivelyFullyOptedOut ?? options.legacyIsOptedOut
  if (isFullyOptedOut) return { status: 'yes' }

  // This column is an audit view of everyone the BE reports as opted out — it names all of them,
  // including users the "Opt out for specific Instructor" modal can't currently toggle (e.g.
  // Support Staff, whose roster isn't yet exposed on the CDG row). A "Partial (name)" the admin
  // can't immediately fix from this modal is a smaller problem than silently reading "No" for a
  // section that genuinely has someone opted out.
  const instructors: OptedOutInstructorLike[] = Array.isArray(optedOutInstructors) ? optedOutInstructors : []
  if (instructors.length === 0) return { status: 'no' }

  const names = instructors.map((instructor) => instructor.title)
  const visibleNames = names.length > MAX_VISIBLE_OPTED_OUT_NAMES
    ? `${names.slice(0, MAX_VISIBLE_OPTED_OUT_NAMES).join(', ')}, +${names.length - MAX_VISIBLE_OPTED_OUT_NAMES} more`
    : names.join(', ')

  return {
    status: 'partial',
    visibleText: `Partial (${visibleNames})`,
    fullText: `Partial (${names.join(', ')})`
  }
}
